import Spin from 'antd/lib/spin';
import * as React from 'react';
import { FetchableEntityType } from '../../entityType';
import { MehOutlined } from '@ant-design/icons';
import Result from 'antd/lib/result';
import { antGrey } from '../styles/globalStyles';
import Button from 'antd/lib/button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { tryFetchEntity } from '../../actions/entities';
import { useError, useIsLoading } from '@/utils/hooks/helpers';
import { selectIsAppStateFetched } from '@/selectors/selectors';

export const AppComponentWrapper: React.FC<{
    children: React.ReactNode;
    orgId: string;
    appId: string;
    showLoader?: boolean;
    showError?: boolean;
}> = (props) => {
    const { children, orgId, appId, showLoader = false, showError = false } = props;

    const [displayError, setDisplayError] = React.useState(false);

    const dispatch = useDispatch();
    const isLoading = useIsLoading(FetchableEntityType.AppState, appId);
    const errorFetching = useError(FetchableEntityType.AppState, appId);
    const isAppFetched = useSelector((state: RootState) => selectIsAppStateFetched(state, appId));

    const fetchAppState = () => {
        setDisplayError(false);

        dispatch(tryFetchEntity(FetchableEntityType.AppState, { orgId, appId }, appId));
    };

    React.useEffect(() => {
        if (!isAppFetched && !isLoading) {
            fetchAppState();
        }
    }, [appId]);

    React.useEffect(() => {
        if (errorFetching) {
            setDisplayError(true);
        }
    }, [errorFetching]);

    return (
        <>
            {isLoading && showLoader && (
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 100,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Spin size="small" />
                </div>
            )}
            {displayError && showError && (
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Result
                        icon={<MehOutlined style={{ color: antGrey.grey5 }} />}
                        subTitle="Error fetching app"
                        extra={<Button onClick={fetchAppState}>Try again</Button>}
                    />
                </div>
            )}
            {isAppFetched && children}
        </>
    );
};
